import React from "react";

export default function GlassCard({
  children,
  className = "",
  onClick,
  highlight = false,
}) {
  return (
    <div
      onClick={onClick}
      className={`glass ${highlight ? "highlight" : ""} ${
        onClick ? "cursor-pointer" : ""
      } ${className}`}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={(e) =>
        onClick && (e.key === "Enter" || e.key === " ") && onClick()
      }
    >
      {children}
    </div>
  );
}
